/**
 *    @author: Andrew Sheen
 *    @since:  2021-03-14
 *
 */

import { ViewportScroller } from '@angular/common';
import { Confirm } from 'src/refresh/service/constant';
import { Util } from 'src/refresh/service/Util';
import { IValidator } from '../_common/component/IValidator';
import { NextRegistrationComponent} from './next_registration.component';

export class NextRegistrationValidation extends IValidator {

       constructor(private component: NextRegistrationComponent){
             super();
             this.viewportScroller = this.component.viewportScroller;
       }

       private success: boolean;
       private viewportScroller:ViewportScroller;

       public validate(): boolean {

            this.success = true;

            if( Util.isEmpty(this.component.data.aboutChild.isNextChild)){
                this.focus('isNextChild','radio_isNextChildRadio_0').error_nextChild = "next_registration.error_empty_nextRegister";
            } 
            else
            if ( this.component.data.aboutChild.isNextChild == Confirm.YES ) {
                if( Util.isEmpty(this.component.data.aboutChild.isSameBirthday)){
                     this.focus('sameBirthday','radio_sameBirthdayRadio_0').error_sameBirthday = "next_registration.error_empty_sameBirthday"; 
                 } 
                 else
                 if( this.component.data.aboutChild.isSameBirthday == Confirm.NO ) {
                     if ( this.component.birthday.validate() == false ) this.success = false;
                 }

                 if( Util.isEmpty(this.component.data.aboutChild.isSameAddress)){
                  this.focus('sameAddress','radio_sameAddressRadio_0').error_sameAddress = "next_registration.error_empty_sameAddress"; 
                  } 

                 if ( this.component.childDeceased.validate() == false ) this.success = false;
            }

            return this.success;
       }

       private focus(tagId:string,ctrlId:string) : NextRegistrationComponent {
            if ( this.success ) {
                 this.viewportScroller.scrollToAnchor(tagId);
                 let ctrl = document.getElementById(ctrlId);
                 ///console.log(ctrl);
                 if ( ctrl ) ctrl.focus();
            }
                 
            this.success = false;
            return this.component;
       }
}

